import { Icon, IconProps } from "@chakra-ui/react";
import cdsColors from "theme/cdsColors";

export default function CaminoEye(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M2.18301 10.1973C1.61634 9.46132 1.33301 9.09266 1.33301 7.99999C1.33301 6.90666 1.61634 6.53932 2.18301 5.80266C3.31434 4.33332 5.21167 2.66666 7.99967 2.66666C10.7877 2.66666 12.685 4.33332 13.8163 5.80266C14.383 6.53999 14.6663 6.90732 14.6663 7.99999C14.6663 9.09332 14.383 9.46066 13.8163 10.1973C12.685 11.6667 10.7877 13.3333 7.99967 13.3333C5.21167 13.3333 3.31434 11.6667 2.18301 10.1973Z"
        stroke={cdsColors.cdsGrey[800]}
        strokeWidth="1"
      />
      <path
        d="M10 8C10 8.53043 9.78929 9.03914 9.41421 9.41421C9.03914 9.78929 8.53043 10 8 10C7.46957 10 6.96086 9.78929 6.58579 9.41421C6.21071 9.03914 6 8.53043 6 8C6 7.46957 6.21071 6.96086 6.58579 6.58579C6.96086 6.21071 7.46957 6 8 6C8.53043 6 9.03914 6.21071 9.41421 6.58579C9.78929 6.96086 10 7.46957 10 8Z"
        stroke={cdsColors.cdsGrey[800]}
        strokeWidth="1"
      />
      <path
        d="M2.18398 10.1986C1.61732 9.46264 1.33398 9.09397 1.33398 8.0013C1.33398 6.90797 1.61732 6.54064 2.18398 5.80397C3.31532 4.33464 5.21265 2.66797 8.00065 2.66797C10.7887 2.66797 12.686 4.33464 13.8173 5.80397C14.384 6.5413 14.6673 6.90864 14.6673 8.0013C14.6673 9.09464 14.384 9.46197 13.8173 10.1986C12.686 11.668 10.7887 13.3346 8.00065 13.3346C5.21265 13.3346 3.31532 11.668 2.18398 10.1986Z"
        stroke={cdsColors.cdsGrey[800]}
        strokeWidth="1"
      />
      <path
        d="M10.001 8.00131C10.001 8.53175 9.79026 9.04045 9.41519 9.41553C9.04012 9.7906 8.53141 10.0013 8.00098 10.0013C7.47054 10.0013 6.96184 9.7906 6.58676 9.41553C6.21169 9.04045 6.00098 8.53175 6.00098 8.00131C6.00098 7.47088 6.21169 6.96217 6.58676 6.5871C6.96184 6.21203 7.47054 6.00131 8.00098 6.00131C8.53141 6.00131 9.04012 6.21203 9.41519 6.5871C9.79026 6.96217 10.001 7.47088 10.001 8.00131Z"
        stroke={cdsColors.cdsGrey[800]}
        strokeWidth="1"
      />
    </Icon>
  );
}
